import { useLayoutEffect } from "react";
import logoPng from "../../img/logo.png";
import wavePng from "../../img/white-wave.png";
import "./Footer.scss";

export default function Footer() {
  useLayoutEffect(() => {
    const footer = document.querySelector(".footer");
    const widgetScript = document.createElement("script");

    widgetScript.innerHTML = `
         (function(w,d,u){
            var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
            var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
         })(window,document,'https://crm.vdkanal.ru/upload/crm/site_button/loader_1_r7ls0p.js');
      `;

    footer.appendChild(widgetScript);
  }, []);

  return (
    <footer className="footer">
      <div className="_container">
        <div className="footer__content">
          <div className="footer__mobile-logo">
            <div className="logo">
              <a className="logo__link" href="/">
                <img className="logo__img" src={logoPng} alt="" />
              </a>
            </div>
          </div>
          <div className="footer__logo-text-wrap">
            <div className="logo">
              <a className="logo__link" href="/">
                <img className="logo__img" src={logoPng} alt="" />
              </a>
            </div>
            <div className="footer__text hover-link-trigger">
              <a
                href="/privacy-policy"
                className="hover-link-target"
                target="_blank"
              >
                Политики в отношении обработки и защиты персональных данных
                <br />
                абонентов (потребителей услуг) МУП «Водоканал»
              </a>
            </div>
          </div>
          <div className="footer__links-wrap">
            <a
              className="footer__phone-wrap hover-link-trigger"
              href="tel:+78332256256"
            >
              <div className="icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 13H22C21.9992 12.2046 21.6829 11.442 21.1204 10.8796C20.558 10.3171 19.7954 10.0008 19 10V8C20.3256 8.00159 21.5964 8.52888 22.5338 9.46622C23.4711 10.4036 23.9984 11.6744 24 13Z"
                    fill="#0883D1"
                  ></path>
                  <path
                    d="M28 13H26C25.9979 11.1441 25.2597 9.36489 23.9474 8.05259C22.6351 6.7403 20.8559 6.00212 19 6V4C21.3861 4.00265 23.6738 4.95171 25.361 6.63896C27.0483 8.32622 27.9974 10.6139 28 13Z"
                    fill="#0883D1"
                  ></path>
                  <path
                    d="M20.333 21.482L22.573 19.242C22.8728 18.9421 23.2541 18.7367 23.6695 18.6514C24.0849 18.5661 24.5162 18.6045 24.91 18.762L27.638 19.854C28.0401 20.0149 28.3847 20.2925 28.6275 20.6512C28.8703 21.0098 29 21.4329 29 21.866V26.827C29.0007 27.1219 28.9412 27.4138 28.8252 27.6848C28.7092 27.9559 28.539 28.2005 28.3252 28.4035C28.1114 28.6065 27.8584 28.7638 27.5817 28.8657C27.305 28.9676 27.0104 29.0119 26.716 28.996C7.59399 27.806 3.73198 11.61 3.01498 5.40799C2.98026 5.10479 3.01012 4.79767 3.1026 4.50683C3.19508 4.21599 3.34809 3.94803 3.55156 3.72057C3.75502 3.49311 4.00435 3.3113 4.28312 3.1871C4.56189 3.06291 4.8638 2.99914 5.16898 2.99999H10.042C10.4751 2.99998 10.8982 3.12972 11.2568 3.37249C11.6154 3.61526 11.8931 3.95991 12.054 4.36199L13.145 7.08999C13.3024 7.48377 13.3409 7.91508 13.2556 8.3305C13.1702 8.74591 12.9649 9.12716 12.665 9.42699L10.425 11.667C10.425 11.667 11.667 20.399 20.333 21.482Z"
                    fill="#0883D1"
                  ></path>
                </svg>
              </div>
              <div className="phone-text hover-link-target">(8332)256-256</div>
            </a>
            <ul className="social-links__items">
              <li className="social-links__item">
                <a className="social-links__item-link" href="#" target="_blank">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 0C7.16374 0 0 7.16342 0 16C0 24.8366 7.16374 32 16 32C24.8363 32 32 24.8366 32 16C32 7.16342 24.8363 0 16 0ZM24.1161 17.7305C24.8618 18.4588 25.6507 19.1443 26.3202 19.948C26.6168 20.3036 26.8964 20.6712 27.1092 21.0846C27.413 21.6742 27.1386 22.3208 26.6109 22.3558L23.333 22.3552C22.4864 22.4252 21.8127 22.0838 21.2447 21.505C20.7913 21.0437 20.3707 20.551 19.934 20.0741C19.7555 19.8783 19.5676 19.694 19.3437 19.549C18.8969 19.2583 18.5086 19.3473 18.2526 19.8141C17.9917 20.2891 17.9321 20.8155 17.9072 21.3442C17.8715 22.1172 17.6385 22.3191 16.8629 22.3555C15.2058 22.4331 13.6335 22.1816 12.1721 21.3462C10.8829 20.6093 9.88514 19.5693 9.01565 18.3917C7.32252 16.0962 6.02582 13.5768 4.86073 10.9851C4.59851 10.4014 4.79034 10.0891 5.43427 10.077C6.5041 10.0563 7.57393 10.059 8.64376 10.076C9.07916 10.0829 9.36724 10.332 9.53453 10.7428C10.1127 12.1652 10.8214 13.5186 11.7095 14.7737C11.9462 15.1079 12.1878 15.4412 12.5319 15.6772C12.9116 15.9378 13.201 15.8517 13.3801 15.4278C13.4947 15.1583 13.5441 14.8703 13.569 14.5815C13.6541 13.5926 13.6642 12.6039 13.5169 11.6189C13.4253 11.0024 13.0786 10.6044 12.4641 10.4878C12.1512 10.4286 12.197 10.3127 12.3492 10.1339C12.6134 9.8249 12.8609 9.63372 13.3555 9.63372L17.059 9.63306C17.6427 9.74764 17.7737 10.0095 17.8529 10.5975L17.8562 14.7131C17.8493 14.9406 17.9704 15.615 18.379 15.764C18.7063 15.872 18.9224 15.6095 19.1182 15.4022C20.0063 14.4597 20.6391 13.3474 21.2058 12.196C21.4559 11.6883 21.6716 11.1628 21.8811 10.6364C22.0369 10.2472 22.2792 10.0557 22.7185 10.0622L26.2848 10.0665C26.3899 10.0665 26.4967 10.0675 26.6008 10.0855C27.2018 10.1883 27.3665 10.4469 27.1805 11.0332C26.8879 11.9544 26.3192 12.7218 25.7634 13.4911C25.1675 14.3147 24.5321 15.1096 23.9422 15.9368C23.4001 16.693 23.443 17.0738 24.1161 17.7305Z"
                      fill="#0883D1"
                    ></path>
                  </svg>
                </a>
              </li>
              <li className="social-links__item">
                <a className="social-links__item-link" href="#" target="_blank">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M32 16C32 7.1625 24.8375 0 16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C16.0938 32 16.1875 32 16.2812 31.9937V19.5438H12.8438V15.5375H16.2812V12.5875C16.2812 9.16875 18.3688 7.30625 21.4188 7.30625C22.8813 7.30625 24.1375 7.4125 24.5 7.4625V11.0375H22.4C20.7437 11.0375 20.4188 11.825 20.4188 12.9812V15.5312H24.3875L23.8687 19.5375H20.4188V31.3813C27.1063 29.4625 32 23.3062 32 16Z"
                      fill="#0883D1"
                    ></path>
                  </svg>
                </a>
              </li>
              <li className="social-links__item">
                <a className="social-links__item-link" href="#" target="_blank">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.0625 16C19.0625 17.6914 17.6914 19.0625 16 19.0625C14.3086 19.0625 12.9375 17.6914 12.9375 16C12.9375 14.3086 14.3086 12.9375 16 12.9375C17.6914 12.9375 19.0625 14.3086 19.0625 16Z"
                      fill="#0883D1"
                    ></path>
                    <path
                      d="M23.1621 10.5815C23.0149 10.1826 22.78 9.82153 22.4749 9.52515C22.1785 9.21997 21.8176 8.98511 21.4185 8.83789C21.0947 8.71216 20.6084 8.5625 19.7126 8.52173C18.7437 8.47754 18.4531 8.46802 16 8.46802C13.5466 8.46802 13.2561 8.47729 12.2874 8.52148C11.3916 8.5625 10.905 8.71216 10.5815 8.83789C10.1824 8.98511 9.82129 9.21997 9.52515 9.52515C9.21997 9.82153 8.98511 10.1824 8.83765 10.5815C8.71191 10.9053 8.56226 11.3918 8.52148 12.2876C8.47729 13.2563 8.46777 13.5469 8.46777 16.0002C8.46777 18.4534 8.47729 18.7439 8.52148 19.7129C8.56226 20.6086 8.71191 21.095 8.83765 21.4187C8.98511 21.8179 9.21973 22.1787 9.5249 22.4751C9.82129 22.7803 10.1821 23.0151 10.5813 23.1624C10.905 23.2883 11.3916 23.438 12.2874 23.4788C13.2561 23.5229 13.5464 23.5322 15.9998 23.5322C18.4534 23.5322 18.7439 23.5229 19.7124 23.4788C20.6082 23.438 21.0947 23.2883 21.4185 23.1624C22.2197 22.8533 22.853 22.22 23.1621 21.4187C23.2878 21.095 23.4375 20.6086 23.4785 19.7129C23.5227 18.7439 23.532 18.4534 23.532 16.0002C23.532 13.5469 23.5227 13.2563 23.4785 12.2876C23.4377 11.3918 23.2881 10.9053 23.1621 10.5815ZM16 20.7178C13.3943 20.7178 11.282 18.6057 11.282 16C11.282 13.3943 13.3943 11.2822 16 11.2822C18.6055 11.2822 20.7178 13.3943 20.7178 16C20.7178 18.6057 18.6055 20.7178 16 20.7178ZM20.9043 12.1982C20.2954 12.1982 19.8018 11.7046 19.8018 11.0957C19.8018 10.4868 20.2954 9.99316 20.9043 9.99316C21.5132 9.99316 22.0068 10.4868 22.0068 11.0957C22.0066 11.7046 21.5132 12.1982 20.9043 12.1982Z"
                      fill="#0883D1"
                    ></path>
                    <path
                      d="M16 0C7.16479 0 0 7.16479 0 16C0 24.8352 7.16479 32 16 32C24.8352 32 32 24.8352 32 16C32 7.16479 24.8352 0 16 0ZM25.1321 19.7878C25.0876 20.7659 24.9321 21.4336 24.7051 22.0181C24.2278 23.2522 23.2522 24.2278 22.0181 24.7051C21.4338 24.9321 20.7659 25.0874 19.7881 25.1321C18.8083 25.1768 18.4954 25.1875 16.0002 25.1875C13.5049 25.1875 13.1921 25.1768 12.2122 25.1321C11.2344 25.0874 10.5664 24.9321 9.98218 24.7051C9.3689 24.4744 8.81372 24.1128 8.35474 23.6453C7.88745 23.1865 7.52588 22.6311 7.29517 22.0181C7.06812 21.4338 6.9126 20.7659 6.86816 19.7881C6.823 18.8081 6.8125 18.4951 6.8125 16C6.8125 13.5049 6.823 13.1919 6.86792 12.2122C6.91235 11.2341 7.06763 10.5664 7.29468 9.98193C7.52539 9.3689 7.88721 8.81348 8.35474 8.35474C8.81348 7.88721 9.3689 7.52563 9.98193 7.29492C10.5664 7.06787 11.2341 6.9126 12.2122 6.86792C13.1919 6.82324 13.5049 6.8125 16 6.8125C18.4951 6.8125 18.8081 6.82324 19.7878 6.86816C20.7659 6.9126 21.4336 7.06787 22.0181 7.29468C22.6311 7.52539 23.1865 7.88721 23.6455 8.35474C24.1128 8.81372 24.4746 9.3689 24.7051 9.98193C24.9324 10.5664 25.0876 11.2341 25.1323 12.2122C25.177 13.1919 25.1875 13.5049 25.1875 16C25.1875 18.4951 25.177 18.8081 25.1321 19.7878Z"
                      fill="#0883D1"
                    ></path>
                  </svg>
                </a>
              </li>
              <li className="social-links__item">
                <a className="social-links__item-link" href="#" target="_blank">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="16" cy="16" r="16" fill="#0883D1"></circle>
                    <path
                      d="M25.607 11.203C25.4931 10.7804 25.2705 10.395 24.9614 10.0852C24.6522 9.77534 24.2673 9.55187 23.845 9.43701C22.279 9.00701 16.014 9.00001 16.014 9.00001C16.014 9.00001 9.75 8.99301 8.183 9.40401C7.76093 9.52415 7.37682 9.75078 7.06757 10.0621C6.75831 10.3735 6.53429 10.7591 6.417 11.182C6.004 12.748 6 15.996 6 15.996C6 15.996 5.996 19.26 6.406 20.81C6.636 21.667 7.311 22.344 8.169 22.575C9.751 23.005 15.999 23.012 15.999 23.012C15.999 23.012 22.264 23.019 23.83 22.609C24.2525 22.4943 24.6377 22.2714 24.9477 21.9622C25.2576 21.653 25.4814 21.2682 25.597 20.846C26.011 19.281 26.014 16.034 26.014 16.034C26.014 16.034 26.034 12.769 25.607 11.203ZM14.01 19.005L14.015 13.005L19.222 16.01L14.01 19.005Z"
                      fill="white"
                    ></path>
                  </svg>
                </a>
              </li>
              <li className="social-links__item">
                <a
                  className="social-links__item-link"
                  href="https://t.me/VdkanalInteractiveDashboardBot"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 496 512"
                  >
                    <path
                      fill="#0883D1"
                      d="M248 8a248 248 0 1 0 0 496 248 248 0 0 0 0-496Zm115 169c-4 39-20 134-28 178-4 19-10 25-17 25-14 2-25-9-39-18l-56-37c-24-17-8-25 6-40 3-4 67-61 68-67l-1-4-5-1q-4 1-105 70-15 10-27 9c-9 0-26-5-38-9-16-5-28-7-27-16q1-7 18-14l145-62c69-29 83-34 92-34 2 0 7 1 10 3a10 10 0 0 1 4 7 44 44 0 0 1 0 10Z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer__design-block">
        <img src={wavePng} alt="" />
      </div>
    </footer>
  );
}
